import _ from "underscore";
import { Toast } from "mint-ui";
import dayjs from "@app/js/lib/dayjs";
import cookie from "../lib/cookie";
import SEARCHCONSTANT from "../constant/search";
import AUTHCONSTANT from "../constant/auth";
import COOKIECONSTANT from "../constant/cookie";
import COMMONCONSTANT from "../constant/common";
import HOME_CONSTANT from "../constant/home";
import OCONSTANT from "../constant/order";
import BCONSTANT from "../constant/business";
import { setCustomizedHeader } from "../util/x_client_info.js";

import distance from "gps-distance";
import Api from "../lib/request";
import co from "../data/co";
import md5 from "MD5";
import qs from "querystring";
import op from "object-path";
import sdtj from "@sdtj/util";

export const authPathNameList = [
  "user",
  "userGroupOrder",
  "userOrderDetail",
  "userOrderDetailOld",
  "preorderPayCallback",
  "preorderPayWechat",
  "addressList",
  "userAddress",
  "userAddressUpdate",
  "userAddressAdd",
  "userAddressSelect",
  "userCard",
  "preorderCards",
  "userCardQuery",
  "preorderCardQuery",
  "userCardDetail",
  "preorderCardDetail",
  "cardConsume",
  "cardConsumeDetail",
  "preorder",
  "cardPassword",
  "userCoupon",
  "preorderCoupon",
  "logistics",
  "refundApply",
  "refundDetail",
  "refundList",
  "userBalance",
  "selfServiceOrder",
  "welfare",
  "fenqileLogin",
  "giftOrderList",
  "userExamine",
  "userOrder",
  "customerService",
];

export const toYuan = (point) => (+point / 100).toFixed(2);

export const isLogged = () =>
  !!cookie(COOKIECONSTANT.COOKIE_USER_ID) &&
  !!cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN);

export const toLogin = (url, type) => {
  const toUrl = url || window.location.href;
  return (window.location.href = `${
    AUTHCONSTANT.AUTH_LOGIN_PAGE_URL
  }?redirectUri=${encodeURIComponent(toUrl)}`);
};

export const toBindWechatAccount = (url) => {
  const toUrl = url || window.location.href;
  const ret = `${
    AUTHCONSTANT.AUTH_WECHAT_AUTHORITY_URL
  }?url=${encodeURIComponent(toUrl)}`;
  return (window.location.href = ret);
};

export const logout = (needToLogin = false) => {
  localStorage.clear();
  // clearAllCookie()
  cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN, null);
  cookie(COOKIECONSTANT.COOKIE_USER_ID, null);
  cookie(COOKIECONSTANT.COOKIE_USER_MOBILE, null);
  cookie(COOKIECONSTANT.COOKIE_USER_NAME, null);
  cookie(COOKIECONSTANT.COOKIE_USER_THIRD_OPENID, null);
  cookie(COOKIECONSTANT.COOKIE_USER_THIRD_TYPE, null);
  if (needToLogin) {
    toLogin();
  }
};

// 价格格式化，小数点后两位
export const priceConversion = (value) =>
  Math.round((+value / 100) * Math.pow(10, 2)) / Math.pow(10, 2);
// 得到价格的小数部分
export const priceFloat = (v) => {
  if (v < 0) {
    return "";
  }
  v = v.toString();
  const index = v.indexOf(".");
  if (!~index) {
    return "";
  }
  return v.substr(index);
};
// 价格整数部分
export const priceInt = (v) => {
  v = v.toString();
  const index = v.indexOf(".");
  if (!~index) {
    return v;
  }
  return v.substr(0, index);
};

// 直接返回正确的价格格式（保留小数两位、如果末尾小数是0则舍去）
export const rightPrice = (v) =>
  priceFloat(toYuan(v)) == ".00"
    ? priceInt(toYuan(v))
    : priceInt(priceConversion(v)) + priceFloat(priceConversion(v));

/**
 * 解析 actionType 跳转路径
 * 详细文档参考 http://doc.maizuo.com/note/5901d4df657c2a4ec4000000
 * @param {object} param0 公共跳转参数
 * @param {string} businessType 业务类型
 * @param {number} isNeedCurrentQuery 是否需要带上当前路由参数
 */
export const resolveActionPath = (
  { actionType, actionData } = {},
  isNeedCurrentQuery = 0
) => {
  let queryStr = "",
    pathObject = {};
  if (isNeedCurrentQuery) {
    queryStr = location.hash.split("?")[1];
  }
  if (typeof actionData === "string") {
    actionData = actionData && JSON.parse(actionData);
  }

  switch (actionType) {
    case 1:
      pathObject = { path: "/" };
      break;
    case 2:
      pathObject = { path: "/", query: { redirect: actionData.url } };
      break;
    case 3:
      pathObject = { path: "/" };
      break;
    case 4:
      pathObject = { path: "/search", query: { keyword: actionData.txt } };
      break;
    case 5:
      const rechargeType = ["fuel", "cost", "flow"];
      let activeType = rechargeType[actionData.businessId - 1];
      if (!activeType) {
        activeType = "fuel";
      }
      pathObject = {
        path: `/recharge/${activeType}?vipType=${
          isNaN(+actionData.childId) ? 0 : actionData.childId
        }`,
      }; // vipType : 0超级卡充值,1普通卡充值)
      break;
    case 6:
      pathObject = {
        path: `/category/${actionData.businessId}${
          actionData.param && actionData.param == 1 ? "/filter" : ""
        }`,
      };
      break;
    case 7:
      const actionId = actionData.businessId || actionData.childId;

      if (actionData.param == "1") {
        pathObject = { path: `/product/${actionId}` };
      } else {
        pathObject = { path: `/group/${actionId}` };
      }
      break;
    case 8:
      pathObject = { path: `/topic/${actionData.businessId}` };
      break;
    case 9:
      pathObject = { path: "/center" };
      break;
    case 10:
      pathObject = { path: "/user" };
      break;
    case 11:
      pathObject = { path: "/user/address" };
      break;
    case 12:
      pathObject = { path: "/user/card" };
      break;
    case 13:
      pathObject = { path: "/cart" };
      break;
    case 14:
      pathObject = { path: "/user/order" };
      break;
    case 15:
      if (actionData.param == 1) {
        // 0 普通订单 1 礼物订单
        pathObject = {
          path: `/user/order/${actionData.businessId}?businessType=${OCONSTANT.ORDER_BUSINESS_TYPE_IS_GIFT}`,
        };
      }
      pathObject = { path: `/user/order/${actionData.businessId}?type=1` }; // type: 1 已支付订单 、2 待支付订单
      break;
    case 16:
      const urlRE = /^(((https?|ftp|news):\/\/|\w+(\.\w+)+)(:\w+)?).*/;
      if (urlRE.test(actionData.businessId)) {
        pathObject = { path: "/", query: { redirect: actionData.businessId } };
      }
      pathObject = { path: `/card/query/${actionData.businessId}` };
      break;
    case 17:
      pathObject = {
        path: "/",
        query: { redirect: COMMONCONSTANT.SDYXMALL_MOVIE_HOST },
      };
      break;
    case 18:
      pathObject = { path: "/enterprise" };
      break;
    case 19:
      pathObject = {
        path: `/category/${actionData.businessId}`,
        query: { type: SEARCHCONSTANT.SEARCH_TYPE_IS_ENTERPRISE },
      };
      break;
    case 20:
      pathObject = { path: "/enterprise" };
      break;
    case 21: // (已废弃)
      pathObject = { path: "/search/result2", query: actionData };
      break;
    case 22:
      pathObject = {
        path: "/",
        query: {
          redirect: `${COMMONCONSTANT.SDYXMALL_MOVIE_HOST}#/film/${actionData.businessId}`,
        },
      };
      break;
    case 23:
      pathObject = {
        path: "/",
        query: {
          redirect: `${COMMONCONSTANT.SDYXMALL_MOVIE_HOST}#/cinema/${actionData.businessId}/film`,
        },
      };
      break;
    case 24:
      // pathObject = { path: `/group/${actionData.businessId}?groupCode=${actionData.childId || ''}`}
      pathObject = {
        path: "/",
        query: {
          redirect: `${COMMONCONSTANT.SDYXMALL_ACT_HOST}group/${
            actionData.businessId
          }/?groupCode=${actionData.childId || ""}`,
        },
      };
      break;
    case 25:
      // pathObject = { path: '/group'}
      pathObject = {
        path: "/",
        query: { redirect: `${COMMONCONSTANT.SDYXMALL_ACT_HOST}group/` },
      };
      break;
    case 27:
      if (actionData.param == 1) {
        pathObject = {
          path: `/group/join/${actionData.businessId}?groupCode=${
            actionData.childId || ""
          }`,
        };
      }
      pathObject = {
        path: "/",
        query: {
          redirect: `${COMMONCONSTANT.SDYXMALL_ACT_HOST}group/join/${
            actionData.businessId
          }/?groupCode=${actionData.childId || ""}`,
        },
      };
      break;
    case 28:
      pathObject = { path: "/recommend" };
      break;
    case 29:
      pathObject = { path: `/global/${actionData.businessId}` };
      break;
    case 30: // 基地直销
      pathObject = {
        path: `/category/${actionData.businessId}`,
        query: { isInDirectSales: 1 },
      };
      break;
    case 31:
      pathObject = {
        path: "/",
        query: {
          redirect: `${COMMONCONSTANT.SDYXMALL_ACT_HOST}yiyuangou/${
            actionData.businessId
          }/?groupCode=${actionData.childId || ""}`,
        },
      };
      break;
    case 32:
      pathObject = {
        path: "/buyer",
        query: {
          productId: actionData.businessId,
          buyerId: actionData.childId,
        },
      };
      break;
    case 38:
      pathObject = {
        name: "colleaguesBuyShare",
        params: { groupCode: actionData.businessId },
      };
      break;
    case 40:
      pathObject = { name: "zone", params: { id: actionData.businessId } };
      break;
    case 41:
      pathObject = {
        name: "zoneFilter",
        params: { id: actionData.businessId },
      };
      break;
    case 42:
      pathObject = {
        name: "addProducts",
        query: {
          supplierId: actionData.businessId,
          expressRuleIds: actionData.childId,
          maxPrice: actionData.param,
        },
      };
      break;
    case 43:
      if (sdtj.isInMpSdtj) {
        sdtj.jumpMp("productDetail", { productId: actionData.businessId });
        return;
      }
      pathObject = {
        name: "examineItem",
        params: { id: actionData.businessId, maxPrice: actionData.param },
        query: { agencyId: actionData.childId },
      };
      break;
    case 47:
      pathObject = {
        name: "zoneFilter",
        params: { id: actionData.businessId },
        query: { checkPoi: 0 },
      };
      break;
    case 49:
      pathObject = { path: "/examine/filter/package" };
      break;
    case 50:
      pathObject = {
        path: "/examine/filter/agency",
        query: { scope: actionData.param },
      };
      break;
    case 51:
      pathObject = { path: "/examine" };
      break;
    case 52:
      pathObject = { path: "/gift" };
      break;
    case 53: // 档位券品类列表
      pathObject = { path: `/category/welfare/${actionData.businessId}` };
      break;
    case 54: // 档位券商品列表
      pathObject = {
        path: `/category/welfare/simple/${actionData.businessId}`,
      };
      break;
    case 103: // 订单支付
      pathObject = {
        path: `preorder/${actionData.businessId}`,
      };
      break;
    case 104: // 关闭网页
      pathObject = {
        path: ``,
      };
      break;
    case 55: // 商详：档位券businessType = 4(默认) | 提货券businessType = 7
      // 可下单,跳转到普通商详页 ｜ 不可下单,跳转分组聚合商详页
      const param = actionData.param ? JSON.parse(actionData.param) : {};
      const enableOrder =
        _.isEmpty(param) || _.isUndefined(param.enableOrder)
          ? true
          : param.enableOrder;
      pathObject = {
        path: enableOrder
          ? `/product/${actionData.businessId}`
          : `/product/scheme/detail/${actionData.businessId}`,
        query: {
          businessInfo: JSON.stringify({
            businessType:
              param.businessType ||
              OCONSTANT.ORDER_BUSINESS_TYPE_IS_WELFARE_CARD_PRODUCT,
            businessCode: param.businessCode || "",
          }),
        },
      };
      break;
    case 57:
      pathObject = {
        path: `/user/order/self-service/type/${actionData.businessId}`,
      };
      break;
    case 58:
      pathObject = {
        path: `/category/${actionData.businessId}`,
        query: { showType: HOME_CONSTANT.GOODS_LIST_SHOW_TYPE_COURSE },
      };
      break;
    case 59: // 卡适用商品列表
      pathObject = { path: `/product/group/${actionData.businessId}` };
      break;
    case 60: // 商品模板聚合页
      pathObject = { path: `/product/scheme/${actionData.businessId}` };
      break;
    case 65: // 大麦网
      pathObject = { path: actionData.childId };
      break;
    default:
      pathObject = { path: window.location.hash.replace("#", "") };
      // pathObject = {};
      break;
  }
  // eslint-disable-next-line consistent-return
  return {
    ...pathObject,
    query: {
      ...pathObject.query,
      ...qs.parse(queryStr),
    },
  };
};

export const resolveShareUrl = ({ actionType, actionData, eventId }) => {
  const co =
    cookie(COOKIECONSTANT.COOKIE_CO) || COOKIECONSTANT.COOKIE_DEFAULT_CO;
  return `${
    COOKIECONSTANT.ORIGIN_HOST
  }/v1/#/commonShare?actionType=${actionType}&actionData=${encodeURIComponent(
    JSON.stringify(actionData)
  )}`;
};

// 解析商品详情跳转路径
export const resolveProductPath = (productId, param) => {
  if (param == "1") {
    return { path: `/product/${productId}` };
  }
  return { path: `/group/${productId}` };
};

// localstorage 操作
export const historyStorageFun = function (
  storageKey = SEARCHCONSTANT.SEARCH_HISTORY_KEY
) {
  return {
    set(data) {
      return localStorage.setItem(storageKey, JSON.stringify(data));
    },
    get() {
      return JSON.parse(localStorage.getItem(storageKey)) || [];
    },
    clear() {
      return localStorage.removeItem(storageKey);
    },
  };
};

export const getHostName = () =>
  `${window.location.protocol}//${window.location.hostname}`;

// var has = function (obj, keys) {
//   keys = _.toArray(arguments).slice(1);
//   return _.every(keys, _.partial(_.has, obj));
// };

export const hasOptions = (obj, ...args) =>
  _.every(args, _.partial(_.has, obj));
// 设置input光标位置
export const setCaretPosition = (textDom, pos) => {
  setTimeout(() => {
    if (textDom.setSelectionRange) {
      // IE Support
      textDom.setSelectionRange(pos, pos);
      textDom.focus();
    } else if (textDom.createTextRange) {
      // Firefox support
      const range = textDom.createTextRange();
      range.collapse(true);
      range.moveEnd("character", pos);
      range.moveStart("character", pos);
      range.select();
    }
  }, 10);
};

export const getCurrentCity = function () {
  return new Promise((resolve, reject) => {
    // 设置 timeout
    // const getPositionTimeout = setTimeout(function () {
    //   Toast({
    //     message: 'GPS定位失败',
    //     position: 'bottom',
    //     duration: 3000
    //   })
    //   reject(new Error('GPS定位失败'))
    // }, 4000)
    try {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // clearTimeout(getPositionTimeout)
          setCustomizedHeader({
            la: `${position.coords.latitude}`,
            lo: `${position.coords.longitude}`,
          });
          // const clientInfo = { lo: `${position.coords.latitude}`, la: `${position.coords.longitude}` };
          const url = `${COOKIECONSTANT.REQUEST_HOST}`;
          Api.get(url, {
            headers: {
              "X-Host": "mall.film-ticket.city.locate",
              "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
              // 'X-Client-Info': clientInfo,
              latitude: position.coords.latitude || "",
              longitude: position.coords.longitude || "",
            },
          })
            .then((data) => {
              if (data.status !== 0) {
                return reject(data.msg);
              }
              if (_.isEmpty(data.data)) {
                return resolve(data.data);
              }
              resolve(data.data.city);
            })
            .catch((e) => {
              reject(e);
            });
        },
        (e) => {
          // clearTimeout(getPositionTimeout)
          Toast({
            message: "GPS定位失败",
            position: "bottom",
            duration: 3000,
          });
          return reject(e);
        }
      );
    } catch (e) {
      Toast({
        message: "GPS定位失败",
        position: "bottom",
        duration: 3000,
      });
      return reject(e);
    }
  });
};

export const getUrlparam = (param) => {
  const reg = new RegExp(`(^|&)${param}=([^&]*)(&|$)`);
  const r =
    window.location.search.substr(1).match(reg) ||
    window.location.hash
      .substring(window.location.hash.search(/\?/) + 1)
      .match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
};

// 获取两地之间的距离
export const getDistanceBetween = function (source, dest) {
  const slat = +source.split(":")[0] || 0;
  const slon = +source.split(":")[1] || 0;
  const dlat = +dest.split(":")[0] || 0;
  const dlon = +dest.split(":")[1] || 0;

  if (slat === 0 || slon === 0 || dlat === 0 || dlon === 0) {
    return "距离未知";
  }
  const d = distance(slat, slon, dlat, dlon);
  return +d.toFixed(1);
};
/**
 *
 * @param {string} source 目的地latitude:longitude
 * @param {string} dest 起始地latitude:longitude
 */
export const getDistanceBetween2 = function (source, dest) {
  const slat = +source.split(":")[0] || 0;
  const slon = +source.split(":")[1] || 0;
  const dlat = +dest.split(":")[0] || 0;
  const dlon = +dest.split(":")[1] || 0;

  if (slat === 0 || slon === 0 || dlat === 0 || dlon === 0) {
    return "未知";
  }
  const d = distance(slat, slon, dlat, dlon);
  return `${d.toFixed(1)}km`;
};

export const getCitysByIds = function (cityIds) {
  import("../data/citys.json").then((citysData) =>
    _.map(cityIds, (id) => _.find(citysData.list, (city) => city.id == id))
  );
};

export const getAmount = (epayDetailList, epayType) =>
  _.chain(epayDetailList)
    .filter((num) => num.epayType == epayType)
    .pluck("epayAmount")
    .reduce((memo, num) => memo + num, 0)
    .value();

export const getPayTypeText = (payType) => {
  switch (parseInt(payType)) {
    case 1:
    case 11:
      return "支付宝";
    case 2:
    case 20:
    case 21:
      return "微信";
    case 3:
      return "银联";
    case 41:
      return "分期";
    case 6:
      return "分期乐";
    default:
      return "非现金";
  }
};

export const getZhDay = (day) => {
  switch (day) {
    case "0":
      return "星期日";
    case "1":
      return "星期一";
    case "2":
      return "星期二";
    case "3":
      return "星期三";
    case "4":
      return "星期四";
    case "5":
      return "星期五";
    case "6":
      return "星期六";
  }
};

export const remainTime = (endAt) => {
  const now = +dayjs.now();
  const diff = +endAt - now;
  const diffO = dayjs.duration(diff);
  const month = diffO.months();
  const day = diffO.days();
  const hour = diffO.hours();
  const minute = diffO.minutes();
  const second = diffO.seconds();
  const millisecond = `${diffO.milliseconds()}`.substr(0, 1);
  return {
    month,
    day,
    hour,
    minute,
    second,
    millisecond,
  };
};

export const addWaterMark = (url) => {
  if (!url) {
    return "";
  }
  if (!/^https:\/\/mall.s.maizuo.com\/*/.test(url)) {
    return url;
  }
  return `${url}${COMMONCONSTANT.COMMON_SHARE_IMG_WATERMARK_SUFFIX}`;
};
export const serviceStatusText = (value, serviceType) => {
  switch (value) {
    case 0:
    case 8:
    case 11:
      return "等待审核";
    case 1:
      return "等待寄回";
    case 2:
    case 12:
      if (serviceType == 2) {
        return "等待换货";
      }
      // return "待商家收货";
      return "等待退款";
    case 3:
      return "等待退款";
    case 4:
    case 9:
      return "售后关闭";
    case 5:
      if (serviceType == 6) {
        return "已补货";
      }
      return "已换货";
    case 6:
      return "退款到账";
    case 7:
      if (serviceType == 6) {
        return "等待补货";
      }
      return "等待换货";
    default:
      return "";
  }
};
// 优先赔文案
export const youxianpeiText = (value, serviceType) => {
  switch (value) {
    case 0:
    case 8:
      return "等待审核";
    case 1:
      return "等待寄回";
    case 2:
      if (serviceType == 2) {
        return "等待换货";
      }
      // return "待商家收货";
      return "等待退款";
    case 3:
      return "等待退款";
    case 4:
    case 9:
      return "售后关闭";
    case 5:
      return "已换货";
    case 6:
      return "退款到账";
    case 7:
      return "等待换货";
    default:
      return "";
  }
};
export const needFocus = (e) => {
  e.target.focus();
};

export const generateShareLink = (linkData) => {
  const shareData = {};
  const coValue =
    cookie(COOKIECONSTANT.COOKIE_CO) || COMMONCONSTANT.COMMON_DEFAULT_CO;

  shareData.fromUserId = cookie(COOKIECONSTANT.COOKIE_USER_ID);
  shareData.eventId = linkData.eventId;
  // shareData.fromChannelId = COMMONCONSTANT.COMMON_CHANNEL_ID
  shareData.fromAgentId = co[coValue]
    ? co[coValue].agentId
    : co[COMMONCONSTANT.COMMON_DEFAULT_CO].agentId;
  shareData.shareIdentifier = md5(
    `${shareData.fromUserId}&${linkData.eventId}&${
      COMMONCONSTANT.COMMON_CHANNEL_ID
    }&${dayjs().valueOf()}`
  );

  // 分享打开
  if (sessionStore.get("fromUserId")) {
    shareData.shareCount = parseInt(sessionStore.get("shareCount")) + 1;
    shareData.pShareIdentifier = sessionStore.get("shareIdentifier");
  } else {
    shareData.shareCount = 1;
    shareData.pShareIdentifier = "";
  }
  const from = linkData.from || "singlemessage";
  const param = {
    actionType: linkData.actionType,
    actionData: linkData.actionData,
    shareData: JSON.stringify(shareData),
    _rd: +new Date(),
  };
  const query = `?${qs.stringify(param)}`;
  return `${COOKIECONSTANT.ORIGIN_HOST}/v1/?from=${from}#/commonShare${query}`;
};

export const generatePureShareLink = (linkData) => {
  const from = linkData.from || "singlemessage";
  const param = {
    actionType: linkData.actionType,
    actionData: linkData.actionData,
    _rd: +new Date(),
  };
  const query = `?${qs.stringify(param)}`;
  return `${COOKIECONSTANT.ORIGIN_HOST}/v1/?from=${from}#/commonShare${query}`;
};

export const sessionStore = {
  save(data) {
    Object.entries(data).forEach((item) => {
      sessionStorage.setItem(item[0], item[1]);
    });
  },
  get(key) {
    return sessionStorage.getItem(key);
  },
};

export const isNeedAuthPath = (pathName) =>
  authPathNameList.indexOf(pathName) >= 0;

// 3天以上的时间统一x天x时，精确到时，例5天4时；如果是5天0时，精确到天，5天；
// 3天以内包含3天的，以小时展示，72小时；
// 不足1小时的，以分钟展示，59分、58分，不精确到秒；
// 不足1分钟的，按1分钟展示，不精确到秒
export const computeRestTime = function (end, start) {
  const startM = start === undefined ? dayjs() : dayjs.unix(start);
  const endM = dayjs.unix(end);
  if (startM.valueOf() > endM.valueOf()) {
    return "已结束";
  }

  const diffDay = endM.diff(startM, "day");
  if (diffDay >= 3) {
    const StartDiffM = startM;
    const hour = endM.diff(StartDiffM.add(diffDay, "day"), "hour");
    return `${diffDay}天${hour}小时`;
  }
  const diffHour = endM.diff(startM, "hour");
  if (diffHour >= 1) {
    return `${diffHour}小时`;
  }
  const diffMinute = endM.diff(startM, "minute") || 1;
  return `${diffMinute}分`;
};

export const secondCountDown = (endAt, startAt, isMilliseconds = 1) => {
  const end = dayjs.unix(endAt);
  const start = startAt || +dayjs.now();
  const diff = end - start;
  const diffO = dayjs.duration(diff);
  const month = diffO.months();
  let day = diffO.days();
  let hour = diffO.hours();
  let minute = diffO.minutes();
  let second = diffO.seconds();
  let ms = diffO.milliseconds();
  let ret = "";
  if (diff < 0) {
    return "已结束";
  }
  if (day >= 1) {
    day = day * 24 + hour;
    ret += `${day}:`;
  } else if (hour >= 0) {
    hour < 10 ? (hour = `0${hour}`) : null;
    ret += `${hour}:`;
  }
  if (minute >= 0) {
    minute < 10 ? (minute = `0${minute}`) : null;
    ret += `${minute}:`;
  }
  if (second >= 0) {
    second < 10 ? (second = `0${second}`) : null;
    ret += `${second}`;
  }
  // 获取百毫秒
  ms = Math.floor(ms / 100);
  if (isMilliseconds) {
    ret += `:${ms}`;
  }
  return ret;
};

// 获取file对象的Url
export const getObjectURL = (file) => {
  if (!file) {
    return "";
  }
  let url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
};
/**
 *@param {string} value 高德api返回adcode = 省+市+区 6位编码
 */
export const cityIdFormat = (value) => {
  value += "";
  if (!value) {
    return "";
  }
  return +`${value.substr(0, 4)}00`;
};

export const provinceIdFormat = (value) => {
  value += "";
  if (!value) {
    return "";
  }
  return +`${value.substr(0, 2)}0000`;
};
/**
 * @param {string} value 带有换行符的字符串
 */
export const resolveText2Wrap = (value) => {
  if (value) {
    const str = value.replace(/(\\r\\n)|(\\n)|(\n)|(\r\n)/g, ",");
    const arr = str.split(",") || [];
    if (arr.length) {
      for (let i = 0; i < arr.length; i++) {
        arr[i] = `<p class="overflow">${arr[i]}</p>`;
      }
      return arr.join("");
    }
  }
  return value;
};
/**
 *
 * @param {object} data 地址对象
 */
export const resolveAddress = (data) => {
  if (_.isEmpty(data)) {
    return {};
  }
  // 高德api返回adcode = 省+市+区 6位编码
  return {
    cityId: cityIdFormat(op.get(data.addressComponent, "adcode") || ""),
    cityName: op.get(data.addressComponent, "city"),
    districtId: +op(data).get("addressComponent.adcode") || 0,
    districtName: op(data.addressComponent).get("district"),
    provinceId: provinceIdFormat(op(data).get("addressComponent.adcode") || ""),
    provinceName: op(data).get("addressComponent.province") || "",
    name: op(data).get("aois.0.name") || "",
    address: data.formattedAddress || "",
    location: op(data).get("aois.0.location") || {},
    la: op(data).get("aois.0.location.lat") || 0,
    lo: op(data).get("aois.0.location.lng") || 0,
  };
};

/**
 * 时间戳转化日期格式
 */
export const dateFormat = {
  padLeftZero(str) {
    return `00${str}`.substr(str.length);
  },
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
      );
    }
    const o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = `${o[k]}`;
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    return fmt;
  },
};

export const verifyIDNumber = (idNumber) => {
  const idcardReg =
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  return idcardReg.test(idNumber);
};

export const verifyPhoneNumber = (phone) => {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return reg.test(phone);
};

export const verifyHongkongMacaoTaiwanPass = (passNumber) => {
  // 校验港澳台证件
  // 港澳居民来往内地通行证
  // 规则： H/M + 10位或6位数字
  // 样本： H1234567890
  const HongkongMacaoReg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/; // 港澳居民往来大陆通行证

  // 台湾居民来往大陆通行证
  // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
  // 样本： 12345678 或 1234567890B
  const TaiwanReg = /^([0-9]{8}|[0-9]{10})$/; // 台胞证
  return HongkongMacaoReg.test(passNumber) || TaiwanReg.test(passNumber);
};

export const verifyPassport = (passport) => {
  // 护照
  // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
  // 样本： 141234567, G12345678, P1234567
  const reg = /^([a-zA-z]|[0-9]){5,17}$/;
  return reg.test(passport);
};

export const verifyAlphanumeric = (passport) => {
  const reg = /^[0-9a-zA-Z]*$/;
  return reg.test(passport);
};

export const goodsListFormat = (goodsList) =>
  goodsList
    ? goodsList.map((item) => {
        let courseProductAttrText;
        const courseProductAttr = _.find(
          item.attrList,
          (attr) =>
            attr.attrId === HOME_CONSTANT.GOODS_LIST_ATTR_ID_FOR_COURSE_NUM
        );
        if (courseProductAttr) {
          courseProductAttrText = `含${courseProductAttr.attrValue}节课程`;
        }
        return {
          href: item.action ? resolveActionPath(item.action) : "",
          id: item.productId,
          imgUrl: item.imgUrl ? item.imgUrl : item.sku.imgUrl,
          price: item.sku.price,
          groupPrice: item.sku && item.sku.groupPrice,
          marketPrice: item.sku.marketPrice,
          masterName: item.masterName,
          slaveName: item.slaveName,
          count: item.count || 0, // 商品个数 商品聚合预览页特有的
          commonLabel: op(item).get("labels.common"),
          countryImage: op(item).get("labels.country.image") || "",
          rapidAfterSalesImage:
            op(item).get("labels.rapidAfterSales.image") || "",
          skuId: item.sku.skuId,
          totalInventory: item.totalInventory,
          hasVideo: item.hasVideo,
          buyerLabel: op(item.labels).get("buyerShow") || null,
          courseProductAttrText,
        };
      }) || []
    : [];

// 检查当前浏览器是否支持webp格式
export const checkWebp = (() => {
  let isSupportWebp = false;
  try {
    isSupportWebp =
      document
        .createElement("canvas")
        .toDataURL("image/webp")
        .indexOf("data:image/webp") == 0;
  } catch (err) {
    isSupportWebp = false;
  }

  return () => isSupportWebp;
})();

// 获得当前窗口的高度
export const getClientHeight = (() => {
  let clientHeight = 0;
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight =
      document.body.clientHeight < document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  } else {
    clientHeight =
      document.body.clientHeight > document.documentElement.clientHeight
        ? document.body.clientHeight
        : document.documentElement.clientHeight;
  }
  return () => clientHeight;
})();

// 计算组件是否在视野内
export const isElmInView = (el) => {
  const CLIENT_HEIGHT = getClientHeight();
  if (!el.getBoundingClientRect) {
    // 兼容不支持getBoundingClientRect的情况
    return true;
  }
  const { top } = el.getBoundingClientRect();
  if (top <= CLIENT_HEIGHT) {
    return true;
  }
  return false;
};

// 数组分组
export const sliceGroup = (array, subGroupLength) => {
  let index = 0;
  const newArray = [];

  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)));
  }

  return newArray;
};

export const redirect = function (location = "/") {
  const hashReg = /^#w+/;
  if (hashReg.test(location)) {
    return (window.location.hash = location);
  }
  window.location.href = location;
};

export const getCardDueDateMounts = function (cardEndDate) {
  // 计算卡过期了几个月
  let today = dayjs().format("YYYY-MM-DD");
  let endDate = dayjs(dayjs.unix(cardEndDate)).format("YYYY-MM-DD");
  return Math.ceil(dayjs(today).diff(dayjs(endDate), "days") / 30);
};

// 清除所有 cookie
export const clearAllCookie = () => {
  // eslint-disable-next-line no-useless-escape
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    keys.forEach((key) => {
      cookie(key, null);
    });
  }
};
